import dayjs from "dayjs"
import { DateTime, TimeOnly } from "../@client/System"

export function isTimeOnly(value: string): value is TimeOnly {
  if (typeof value !== "string") return false
  if (value.length !== 8) return false
  const timeParts = value.split(":")
  if (timeParts.length !== 3) return false
  return true
}

export function getFormattedTime(
  value: DateTime | TimeOnly | string | null | undefined
) {
  if (value === null) {
    return ""
  }
  let stringValue = value as string
  if (value && isTimeOnly(value)) {
    stringValue = "0000-00-00T" + value
  }
  return dayjs(stringValue).format("LT")
}

export function getFormattedTimePeriod(
  timePeriod?:
    | {
        start?: string | null | undefined
        end?: string | null | undefined
      }
    | null
    | undefined
) {
  let result = ""
  if (timePeriod) {
    if (timePeriod.start) {
      result += getFormattedTime(timePeriod.start)
    }
    if (timePeriod.end && timePeriod.end !== null) {
      result += "-"
      result += getFormattedTime(timePeriod.end)
    }
  }
  return result
}
